import { KeycloakTokenParsed } from 'keycloak-js';
import { create } from 'zustand';

export type RoleValue = string[] | { roles: string[] };

export type UserData = {
  name: string;
  email: string;
  phoneNumber: string;
};

export type UserRoles = {
  frontolCloudClientRoles: string[];
  roleServiceClientRoles: string[];
}

interface UserState {
  initialLoad: boolean;
  token: string | null;
  user: UserData;
  roles: UserRoles;
  isLoading: boolean;
  logout: () => void;
  mainPageUrl: string;
  setAuthData(token: string, user: KeycloakTokenParsed): void;
}

export const useUserStore = create<UserState>((set) => ({
  initialLoad: false,
  user: {
    name: '',
    email: '',
    phoneNumber: '',
  },
  roles: {
    frontolCloudClientRoles: [],
    roleServiceClientRoles: [],
  },
  token: null,
  isLoading: false,
  mainPageUrl: '/',
  setAuthData: (token: string, user: KeycloakTokenParsed) => {
    set({
      initialLoad: true,
      token,
      user: {
        name: user.name,
        email: user.email,
        phoneNumber: user.preferred_username,
      },
      roles: {
        frontolCloudClientRoles: user.resource_access?.frontol_cloud_client?.roles || [],
        roleServiceClientRoles: user.resource_access?.role_service_client?.roles || [],
      }
    })
  },
  logout: () => {
    set({
      initialLoad: false,
      token: null,
      user: {
        name: '',
        email: '',
        phoneNumber: '',
      },
      roles: {
        frontolCloudClientRoles: [],
        roleServiceClientRoles: [],
      }
    });
  },
}));

export type IUser = ReturnType<typeof useUserStore.getState>;
export type IUserSnapshotIn = Partial<UserState>;
export type IUserSnapshotOut = UserState;
